import React from 'react'
import { Text, Title, Icon } from 'components'
import Swiper from 'react-id-swiper'
import classNames from 'classnames'
import styles from './Timeline.module.scss'
import timelineData from './data'

const params = {
  navigation: {
    nextEl: '#nextSlide',
    prevEl: '#prevSlide',
  },
  spaceBetween: 0,
  wrapperClass: styles.timeline,
  slidesPerView: 4,
  breakpoints: {
    1324: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 3.3,
    },
    769: {
      slidesPerView: 2.2,
    },
    480: {
      slidesPerView: 1.2,
    },
    376: {
      slidesPerView: 1.1,
    },
  },
}

const isIphone = window.navigator.userAgent.indexOf('iPhone') !== -1

const Timeline = () => (
  <div className={styles.swiperContainer}>
    <div className={styles.buttonContainer}>
      <button
        type="button"
        id="prevSlide"
        className={classNames(
          { [styles.prevSlideIphone]: isIphone },
          styles.button
        )}
      >
        <Icon type="arrow" size={32} color="primaryColor" />
      </button>
      <button
        type="button"
        id="nextSlide"
        className={classNames(
          styles[isIphone ? 'nextSlideIphone' : 'nextSlide'],
          styles.button
        )}
      >
        <Icon type="arrow" size={32} color="primaryColor" />
      </button>
    </div>
    <Swiper {...params}>
      {timelineData.map((time, index) => (
        <div key={index.toString()} className={styles.swipSlide}>
          <div className={styles.timestamp}>
            <span className={styles.date}>
              <Title
                type="h3"
                color="darkBlueColor"
                fontSize="xxxxlarge"
                className={styles.year}
              >
                {time.year}
              </Title>
            </span>
          </div>
          <div className={styles.status}>
            <Title type="h3" color="darkBlueColor" fontSize="medium">
              {time.mounth}
            </Title>
            <ul>
              {time.descriptions.map((desc, idx) => (
                <li key={idx.toString()}>
                  <Text color="lightTextColor" fontSize="medium">
                    {desc}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </Swiper>
  </div>
)

export default React.memo(Timeline)
